window.$ = window.jQuery;
